import { Link } from "react-router-dom";

export function Home() {
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot" />
            Live Deals Active
          </div>

          <h1 className="hero-title">
            <span className="title-line">
              <span className="glitch-wrapper">
                <span className="glitch-text">PRICE</span>
              </span>
            </span>
            <span className="title-line title-line-accent">
              <span className="glitch-wrapper">
                <span className="glitch-text glitch-text-errors">ERRORS</span>
              </span>
            </span>
          </h1>

          <p className="hero-subtitle">
            Catch Pricing Mistakes Before They're Fixed
          </p>

          <p className="hero-description">
            Join thousands of savvy shoppers who use Price Errors to save money
            every day with real-time price mistakes, pricing glitches, and hidden discounts.
          </p>

          <div className="hero-actions">
            <a
              href="https://discord.gg/q7tErztQDQ"
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="btn-icon">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              Join Free Discord
            </a>
            <a
              href="https://www.pricingerrors.com/"
              className="btn btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Deal Alerts
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="btn-icon">
                <path d="M7 17L17 7M17 7H7M17 7V17"/>
              </svg>
            </a>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <span className="stat-value">24/7</span>
              <span className="stat-label">Deal Monitoring</span>
            </div>
            <div className="stat-divider" />
            <div className="stat">
              <span className="stat-value">FREE</span>
              <span className="stat-label">Community Access</span>
            </div>
            <div className="stat-divider" />
            <div className="stat">
              <span className="stat-value">1000+</span>
              <span className="stat-label">Active Members</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card">
            <div className="card-header">
              <span className="card-badge">PRICE ERROR</span>
              <span className="card-time">Just Now</span>
            </div>
            <div className="card-content">
              <div className="card-product">
                <div className="product-icon">🎮</div>
                <div className="product-info">
                  <span className="product-name">Gaming Headset Pro</span>
                  <span className="product-store">Amazon.com</span>
                </div>
              </div>
              <div className="card-price">
                <span className="price-original">$299.99</span>
                <span className="price-arrow">→</span>
                <span className="price-glitched">$29.99</span>
              </div>
              <div className="card-savings">
                <span className="savings-badge">90% OFF</span>
              </div>
            </div>
          </div>

          <div className="hero-card hero-card-2">
            <div className="card-header">
              <span className="card-badge card-badge-deal">HOT DEAL</span>
              <span className="card-time">2m ago</span>
            </div>
            <div className="card-content">
              <div className="card-product">
                <div className="product-icon">👟</div>
                <div className="product-info">
                  <span className="product-name">Nike Air Max</span>
                  <span className="product-store">Nike.com</span>
                </div>
              </div>
              <div className="card-price">
                <span className="price-original">$180.00</span>
                <span className="price-arrow">→</span>
                <span className="price-glitched">$54.00</span>
              </div>
              <div className="card-savings">
                <span className="savings-badge savings-badge-deal">70% OFF</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section id="what-we-do" className="section section-services">
        <div className="section-inner">
          <div className="section-header">
            <span className="section-tag">SERVICES</span>
            <h2 className="section-title">What We Do</h2>
            <p className="section-description">
              We're building the ultimate ecosystem for deal hunters
            </p>
          </div>

          <div className="services-grid">
            <div className="service-card service-card-main">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                </svg>
              </div>
              <div className="service-content">
                <h3 className="service-title">Free Price Error Alerts</h3>
                <p className="service-description">
                  We track and post the best online price errors and pricing mistakes so you never miss
                  a chance to save. Our primary community is built around
                  <a href="https://x.com/Pricerrors" target="_blank" rel="noopener noreferrer" className="inline-link"> @Pricerrors</a> on X.
                </p>
                <div className="service-features">
                  <span className="feature-tag">Real-time alerts</span>
                  <span className="feature-tag">Price errors</span>
                  <span className="feature-tag">Coupon codes</span>
                </div>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon service-icon-cyan">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
                </svg>
              </div>
              <div className="service-content">
                <h3 className="service-title">Discord Webhook Integration</h3>
                <p className="service-description">
                  Connect your Discord server to receive automatic price error alerts via webhooks.
                  Get instant notifications when new deals drop.
                </p>
                <a href="https://www.pricingerrors.com/add" className="service-link" target="_blank" rel="noopener noreferrer">
                  Add to Discord Server
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>

            <div className="service-card">
              <div className="service-icon service-icon-magenta">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </div>
              <div className="service-content">
                <h3 className="service-title">Email Deal Alerts</h3>
                <p className="service-description">
                  Get price error alerts delivered straight to your inbox. Never miss a deal with our automated email notifications.
                </p>
                <a href="https://www.pricingerrors.com/" className="service-link" target="_blank" rel="noopener noreferrer">
                  Subscribe Now
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to Join Section */}
      <section id="how-to-join" className="section section-join">
        <div className="section-inner">
          <div className="section-header">
            <span className="section-tag">GET STARTED</span>
            <h2 className="section-title">How to Join Us</h2>
            <p className="section-description">
              Three simple steps to start saving
            </p>
          </div>

          <div className="steps-container">
            <div className="step">
              <div className="step-number">01</div>
              <div className="step-content">
                <h3 className="step-title">Follow on X</h3>
                <p className="step-description">
                  Follow <a href="https://x.com/Pricerrors" target="_blank" rel="noopener noreferrer" className="inline-link">@Pricerrors</a> for
                  live price error alerts and hot deals. Turn on notifications to never miss a drop.
                </p>
                <a href="https://x.com/Pricerrors" className="step-link" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="step-link-icon">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                  Follow @Pricerrors
                </a>
              </div>
            </div>

            <div className="step-connector">
              <div className="connector-line" />
              <div className="connector-dot" />
            </div>

            <div className="step">
              <div className="step-number">02</div>
              <div className="step-content">
                <h3 className="step-title">Join Discord</h3>
                <p className="step-description">
                  Get faster notifications, chat with the community, and access member-only
                  tips and early alerts.
                </p>
                <a href="https://discord.gg/q7tErztQDQ" className="step-link step-link-primary" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="step-link-icon">
                    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                  </svg>
                  Join Free Discord
                </a>
              </div>
            </div>

            <div className="step-connector">
              <div className="connector-line" />
              <div className="connector-dot" />
            </div>

            <div className="step">
              <div className="step-number">03</div>
              <div className="step-content">
                <h3 className="step-title">Subscribe for Alerts</h3>
                <p className="step-description">
                  Get price error alerts via email or add our webhook to your Discord server for instant notifications.
                </p>
                <a href="https://www.pricingerrors.com/" className="step-link" target="_blank" rel="noopener noreferrer">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="step-link-icon">
                    <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                  </svg>
                  Get Deal Alerts
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section id="why-us" className="section section-why">
        <div className="section-inner">
          <div className="section-header">
            <span className="section-tag">WHY CHOOSE US</span>
            <h2 className="section-title">Why Price Errors?</h2>
          </div>

          <div className="reasons-grid">
            <div className="reason-card">
              <div className="reason-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
              </div>
              <h3 className="reason-title">Real-time Alerts</h3>
              <p className="reason-description">
                Price errors and hot deals posted the moment they go live. Speed matters when deals die fast.
              </p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <h3 className="reason-title">Curated Alerts</h3>
              <p className="reason-description">
                Carefully selected notifications for the deals that matter most. No spam, just savings.
              </p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3 className="reason-title">Expert Deal Hunters</h3>
              <p className="reason-description">
                Built by experienced deal hunters who do this every day. We know what to look for.
              </p>
            </div>

            <div className="reason-card">
              <div className="reason-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                </svg>
              </div>
              <h3 className="reason-title">Active Community</h3>
              <p className="reason-description">
                Community-focused with active chats, help, and guidance. Learn from fellow deal hunters.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Twitter Feed Placeholder */}
      <section className="section section-feed">
        <div className="section-inner">
          <div className="section-header">
            <span className="section-tag">LIVE FEED</span>
            <h2 className="section-title">Latest from @Pricerrors</h2>
          </div>

          <div className="feed-placeholder">
            <div className="feed-card">
              <svg viewBox="0 0 24 24" fill="currentColor" className="feed-icon">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              <p className="feed-text">Follow <a href="https://x.com/Pricerrors" target="_blank" rel="noopener noreferrer">@Pricerrors</a> on X for live price error updates</p>
              <a href="https://x.com/Pricerrors" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                View on X
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="btn-icon">
                  <path d="M7 17L17 7M17 7H7M17 7V17"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-cta">
        <div className="cta-inner">
          <h2 className="cta-title">
            <span className="glitch-wrapper">
              <span className="glitch-text-cta">Start Saving Today</span>
            </span>
          </h2>
          <p className="cta-description">
            Join our free community and never miss another price error
          </p>
          <div className="cta-actions">
            <a
              href="https://discord.gg/q7tErztQDQ"
              className="btn btn-primary btn-large"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="btn-icon">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              Join the Free Discord
            </a>
            <a
              href="https://www.pricingerrors.com/"
              className="btn btn-outline btn-large"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Deal Alerts
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
